























import Vue from 'vue'

import InputSizeForm from '@/groupBuy/components/requestList/InputSizeForm.vue'

import {
  RequestItemModel,
  GroupBuyRequestAttributes
} from '@/groupBuy/types'

import service from '@/groupBuy/services'
import { SYSTEM_ERROR } from '@/common/constants'

export default Vue.extend({
  components: {
    InputSizeForm
  },
  props: {
    request: {
      type: Object as () => RequestItemModel,
      required: true
    }
  },
  data(): {
    inputFormVisible: boolean
  } {
    return  {
      inputFormVisible: false
    }
  },
  methods: {
    async submitInputSize(payload: GroupBuyRequestAttributes) {
      payload.comment = ''
      const res = await service.submitSizeInput(this.request.uuid, payload).catch(() => {
        return alert(SYSTEM_ERROR.UNKNOWN)
      })
      if (res?.createGroupBuyRequest?.errors?.length) {
        return alert(SYSTEM_ERROR.UNKNOWN)
      }
      this.inputFormVisible = false
    }
  }
})
